import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgVerified = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.2357 2.62603C26.6233 -0.875344 21.3767 -0.875344 18.7643 2.62603C17.3309 4.54714 14.9605 5.52898 12.5886 5.18409C8.26545 4.55551 4.55551 8.26545 5.18409 12.5886C5.52898 14.9605 4.54714 17.3309 2.62603 18.7643C-0.875344 21.3767 -0.875344 26.6233 2.62603 29.2357C4.54714 30.6691 5.52898 33.0395 5.18409 35.4114C4.55551 39.7346 8.26544 43.4445 12.5886 42.8159C14.9605 42.471 17.3309 43.4529 18.7643 45.374C21.3767 48.8753 26.6233 48.8753 29.2357 45.374C30.6691 43.4529 33.0395 42.471 35.4114 42.8159C39.7346 43.4445 43.4445 39.7346 42.8159 35.4114C42.471 33.0395 43.4529 30.6691 45.374 29.2357C48.8753 26.6233 48.8753 21.3767 45.374 18.7643C43.4529 17.3309 42.471 14.9605 42.8159 12.5886C43.4445 8.26544 39.7346 4.55551 35.4114 5.18409C33.0395 5.52898 30.6691 4.54714 29.2357 2.62603Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.9998 14.7583C32.341 14.3238 32.83 14.0514 33.3574 14.0071C33.8826 13.9606 34.4055 14.1446 34.8059 14.5151C35.2083 14.8858 35.4561 15.4158 35.4947 15.9826C35.5333 16.552 35.3605 17.114 35.0128 17.5459L22.5364 33.2516C22.1659 33.7177 21.6293 33.9901 21.0609 34H21.0312C20.4741 34 19.9422 33.7473 19.5669 33.3031L13.5209 26.1645C12.7797 25.291 12.8366 23.9363 13.6461 23.1363C14.4554 22.3387 15.7106 22.4 16.4496 23.2736L20.9834 28.6258L31.9998 14.7583Z", fill: props.fillSecondary }));
});
export default SvgVerified;
